import { render, staticRenderFns } from "./SelectArticleCat.vue?vue&type=template&id=4ce5e964&scoped=true"
import script from "./SelectArticleCat.vue?vue&type=script&lang=js"
export * from "./SelectArticleCat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce5e964",
  null
  
)

export default component.exports